import { render, staticRenderFns } from "./ContactFileModal.vue?vue&type=template&id=f1e3b520&scoped=true"
import script from "./ContactFileModal.vue?vue&type=script&lang=js"
export * from "./ContactFileModal.vue?vue&type=script&lang=js"
import style0 from "./ContactFileModal.vue?vue&type=style&index=0&id=f1e3b520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e3b520",
  null
  
)

export default component.exports